import Commands from './commands';

class SAdd extends Commands {
    constructor(registry) {
        super("sAdd", registry);
    }

    async execute(node, emitter, options) {
        const key = await emitter(node.params[0], options);
        const container = this.registry.get(key) || new Set();
        for (let index = 1; index < node.params.length; index++) {
            container.add(await emitter(node.params[index], options));
        }
        return this.registry.set(key, container);
    }
}

export default SAdd;
